module.exports = __webpack_public_path__ + "static/media/icnWarning.b61213f2.svg";